<div id="app-main-div">
  <div class="baseDiv">
    <router-outlet></router-outlet>
  </div>
</div>
